/** Hjälpare för listning/etiketter av utlämningsplatser. Inga API-anrop. */

export type PickupLocationValidityFields = {
  name?: string;
  isVehiclePool?: boolean;
  bookingsLocked?: boolean;
  validFrom?: string | null;
};

export function localDateYmd(now = new Date()): string {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}

export function isPickupLocationUpcoming(
  pl: Pick<PickupLocationValidityFields, 'validFrom'>,
  today = localDateYmd()
): boolean {
  const from = pl.validFrom?.slice(0, 10);
  return Boolean(from && from > today);
}

export function pickupLocationBookingClosedReason(
  pl: Pick<PickupLocationValidityFields, 'bookingsLocked' | 'validFrom'> | undefined,
  today = localDateYmd()
): 'locked' | 'upcoming' | null {
  if (!pl) return null;
  if (pl.bookingsLocked === true) return 'locked';
  if (isPickupLocationUpcoming(pl, today)) return 'upcoming';
  return null;
}

/** Bilpooler (fordonspooler) går inte att boka eller ändra i Kundtjänst. */
export function isVisibleInCustomerService(
  pl: Pick<PickupLocationValidityFields, 'isVehiclePool'>
): boolean {
  return pl.isVehiclePool !== true;
}

export function pickupLocationOptionLabel(
  pl: Pick<PickupLocationValidityFields, 'name' | 'isVehiclePool' | 'validFrom'>,
  vehiclePoolSuffix: string,
  upcomingSuffix?: string
): string {
  const base = pl.isVehiclePool ? `${pl.name} (${vehiclePoolSuffix})` : (pl.name ?? '');
  if (upcomingSuffix && isPickupLocationUpcoming(pl)) {
    return `${base} (${upcomingSuffix})`;
  }
  return base;
}

export function formatPickupLocationOption(
  pl: Pick<PickupLocationValidityFields, 'name' | 'isVehiclePool' | 'validFrom'>,
  labels: { vehiclePoolSuffix: string; opens: (date: string) => string }
): string {
  const from = pl.validFrom?.slice(0, 10);
  const upcoming = from && isPickupLocationUpcoming(pl) ? labels.opens(from) : undefined;
  return pickupLocationOptionLabel(pl, labels.vehiclePoolSuffix, upcoming);
}
